// src/services/CountryService.js
import api from "./api";

export function getCourseType(page = 1, limit = 10, search = "") {
    return api.get(`/coursetype?page=${page}&limit=${limit}&search=${search}`);
}

export function getCourseTypeById(id) {
    return api.get(`/coursetype/${id}`);
}

export function addCourseType(data) {
    return api.post("/coursetype", data);
}

export function updateCourseType(id, data) {
    return api.put(`/coursetype/${id}`, data);
}

export function deleteCourseType(id) {
    return api.delete(`/coursetype/${id}`);
}
